// src/lib/customerDocTemplate.ts
//
// Email template for customer AR documents (statement / invoice). A default
// template ships here; a per-tenant override is stored in tenant_config keys
// customer_docs.email_subject / customer_docs.email_body (via the admin proxy).
// Placeholders: {customerName} {companyName} {balance} {skippedBlock} {skippedList}

export interface DocTemplate { subject: string; body: string; }

export const DEFAULT_TEMPLATE: DocTemplate = {
  subject: 'Statement of Account — {companyName}',
  body:
`Dear {customerName},

Please see the attached statement of account. Your current balance due is {balance}.
{skippedBlock}
Thank you for your business.

{companyName}`,
};

export function renderTemplate(
  tpl: DocTemplate,
  vars: { customerName: string; companyName: string; balance: string; skippedLines: string[] },
): { subject: string; body: string } {
  const list = vars.skippedLines.map((l) => `  • ${l}`).join('\n');
  const skippedBlock = vars.skippedLines.length
    ? `\nThe following invoices are underpaid or appear to have been skipped:\n${list}\n`
    : '';
  const map: Record<string, string> = {
    '{customerName}': vars.customerName,
    '{companyName}': vars.companyName,
    '{balance}': vars.balance,
    '{skippedBlock}': skippedBlock,
    '{skippedList}': list,
  };
  const sub = (s: string) => Object.entries(map).reduce((a, [k, v]) => a.split(k).join(v), s);
  return { subject: sub(tpl.subject), body: sub(tpl.body) };
}

/** Plain-text body -> minimal HTML for the email (preserves line breaks). */
export function bodyToHtml(body: string): string {
  const esc = (s: string) => s.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c] as string));
  return `<div style="font-family:Arial,sans-serif;font-size:14px;white-space:pre-wrap">${esc(body)}</div>`;
}
